module.exports = __webpack_public_path__ + "./img/avatar-1.813aaa937a298a4334a57ea4315c9406.webp";